import { Box, ModalDialog, Modal, PrimaryButton, SecondaryButton, Typography } from "@husqvarna/ui-core";
import { useIntl } from "react-intl";
import "./ConfirmDelete.scss";

export type ConfirmDeleteProps = {
  headingText: string;
  bodyText: string;
  primaryButtonText: string;
  isOpen?: boolean;
  onConfirm?: () => void;
  onCancel?: () => void;
};

const ConfirmDelete = ({
  headingText,
  bodyText,
  primaryButtonText,
  isOpen,
  onConfirm,
  onCancel
}: ConfirmDeleteProps) => {
  const intl = useIntl();
  return (
    <Modal active={isOpen}>
      <ModalDialog br={6} className="tcsp-confirm">
        <Box my={14} mx={16}>
          <Typography variant="Heading4" mb={2} text={headingText} />
          <Typography variant="Body2" tag="p" text={bodyText} />
          <Box mt={8} textAlign="right">
            <SecondaryButton text={intl.formatMessage({ id: "general.cancel", defaultMessage: "Cancel" })} mr={3} onClick={() => onCancel?.()}/>
            <PrimaryButton text={primaryButtonText} onClick={() => onConfirm?.()} />
          </Box>
        </Box>
      </ModalDialog>
    </Modal>
  );
}

export default ConfirmDelete;
